import { FC, PropsWithChildren } from 'react';

import PrivateLayout from 'src/layouts/PrivateLayout';

const RootLayout: FC<PropsWithChildren> = ({ children }) => {
  return <PrivateLayout>{children}</PrivateLayout>;
};

export default RootLayout;
